import BaseAPI from './BaseAPI';
import Team from '../models/Team';

// Strip V4-only fields before sending to the V3 backend so unknown fields
// don't leak through `team.toJS()`. Done as an explicit allow-list to keep
// the contract obvious and easy to audit.
const toV3Payload = (team) => {
	const { id, name, accountName, deviceIds, urls } = team.toJS();
	return { id, name, accountName, deviceIds, urls };
};

export class TeamAPI extends BaseAPI {

	updateTeam(team: Team) {
		this.request('/sec/v2/team', 'PUT', { team: toV3Payload(team) });
	}
	newTeam(team: Team) {
		this.request('/sec/v2/team', 'POST', { team: toV3Payload(team) });
	}
	deleteTeam(team: Team) {
		this.request('/sec/team', 'DELETE', { id: team.id });
	}

}
